export const scrollToTop = () => {
    setTimeout(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, 10);
}

export const scrollToBottom = () => {
    setTimeout(() => {
        window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: 'smooth',
        });
    }, 10);
};

export const scrollToFooter = () => {
    setTimeout(() => {
        const footer = document.querySelector('footer');
        if (footer) {
            const scrollY = footer.offsetTop - window.innerHeight;
            window.scrollTo({
                top: scrollY >= 0 ? scrollY : 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    }, 10);
};

export const scrollToElement = (element: HTMLElement, offset = 0) => {
    setTimeout(() => {
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth',
        });
    }, 10);
};